import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useViewModel } from "./useViewModel";
import { WelcomeBasicOrgDetailsViewModel } from "./WelcomeBasicOrgDetailsViewModel";
import { WelcomeBasicOrgDetailsFormView } from "./WelcomeBasicOrgDetailsFormView";
import { HXProgressBar } from "./HXProgressBar";
export const WelcomeBasicOrgDetailsView = observer((props) => {
    const model = useViewModel(WelcomeBasicOrgDetailsViewModel, props.container);
    if (!model.organizationId)
        return null;
    return (_jsxs(_Fragment, { children: [model.showProgressBar && _jsx(HXProgressBar, { progress: model.progressBarPercentage }), _jsx(WelcomeBasicOrgDetailsFormView, { container: props.container, onSave: () => model.onSave() })] }));
});
